export default () => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="black"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.2556 0H2.46994C2.04369 0 1.63491 0.169324 1.33351 0.470721C1.03212 0.772119 0.862793 1.1809 0.862793 1.60714L0.862793 13.3929C0.862793 13.8191 1.03212 14.2279 1.33351 14.5293C1.63491 14.8307 2.04369 15 2.46994 15H7.06536V9.90033H4.95598V7.5H7.06536V5.67054C7.06536 3.58962 8.3042 2.44018 10.2016 2.44018C11.1103 2.44018 12.0606 2.60223 12.0606 2.60223V4.64464H11.0136C9.98199 4.64464 9.66023 5.28482 9.66023 5.94141V7.5H11.9631L11.5948 9.90033H9.66023V15H14.2556C14.6819 15 15.0907 14.8307 15.3921 14.5293C15.6935 14.2279 15.8628 13.8191 15.8628 13.3929V1.60714C15.8628 1.1809 15.6935 0.772119 15.3921 0.470721C15.0907 0.169324 14.6819 0 14.2556 0Z"
      fill="inherit"
    />
  </svg>
);
